import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../../services/api';
import './NotificationBell.css';

function BellIcon() {
    return (
        <svg viewBox="0 0 24 24" aria-hidden="true">
            <path
                d="M12 3a5 5 0 0 0-5 5v2.3c0 .9-.3 1.8-.9 2.5L4.4 15a1 1 0 0 0 .8 1.6h13.6a1 1 0 0 0 .8-1.6l-1.7-2.2a4 4 0 0 1-.9-2.5V8a5 5 0 0 0-5-5Zm0 18a2.8 2.8 0 0 0 2.6-1.8h-5.2A2.8 2.8 0 0 0 12 21Z"
                fill="currentColor"
            />
        </svg>
    );
}

export default function NotificationBell() {
    const navigate = useNavigate();
    const [unreadCount, setUnreadCount] = useState(0);

    useEffect(() => {
        let cancelled = false;
        let intervalId = null;

        const fetchUnreadCount = async () => {
            try {
                if (document.visibilityState === 'hidden') {
                    return;
                }

                const response = await api.get('/api/notifications?scope=unread');
                if (!cancelled) {
                    setUnreadCount(Number(response.data?.unreadCount || 0));
                }
            } catch (error) {
                if (!cancelled) {
                    console.error('Не удалось загрузить количество уведомлений:', error);
                }
            }
        };

        void fetchUnreadCount();
        intervalId = setInterval(() => {
            void fetchUnreadCount();
        }, 10000);

        return () => {
            cancelled = true;
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, []);

    return (
        <button
            type="button"
            className="notificationBell"
            onClick={() => navigate('/notifications')}
            aria-label="Открыть уведомления"
        >
            <BellIcon />
            {unreadCount > 0 ? <span className="notificationBell__badge">{unreadCount}</span> : null}
        </button>
    );
}
